import {t} from "@lingui/core/macro";
import {lazy} from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import {Layout, ToolCategories, type Tool} from "../types.ts";

import arrowsCounterClockwiseIcon from "@phosphor-icons/core/regular/arrows-counter-clockwise.svg";

const CoeditingDocumentTool = lazy(
    () => import("../renderers/coediting-document-tool.tsx"),
);

export const textRewriter: Tool = {
    urlSlug: "text-rewriter",
    configName: "teacher-tool-text-rewriter",
    title: () => t`Text rewriter`,
    description: () => t`Customize text to meet your instructional needs`,
    categories: [
        ToolCategories.Differentiate,
        ToolCategories.Create,
        ToolCategories.Support,
    ],
    icon: arrowsCounterClockwiseIcon,
    color: color.fadedRed24,
    layout: Layout.Coeditor,
    reportingLabelId: "text-rewriter",
    exportTargets: [
        "print",
        "download-pdf",
        "download-docx",
        "google-drive-docx",
        "microsoft-onedrive-docx",
    ],
    requestedInputs: [
        {
            description: () => "",
            inputKind: "TEXT_BOX",
            label: () => t`Text title`,
            required: true,
            variableName: "textTitle",
        },
        {
            description: () =>
                t`Input the text that you'd like to be rewritten. This works best on texts with 1,500 words or less.`,
            inputKind: "TEXT_AREA",
            label: () => t`Text`,
            maxCharacters: 26000,
            required: true,
            variableName: "inputText",
        },
        {
            description: () =>
                t`How would you like this text changed? (e.g., convert to bullet points, rewrite in a first-person perspective)`,
            inputKind: "TEXT_AREA",
            label: () => t`Instructions for rewriting`,
            required: true,
            variableName: "rewriteSpecifics",
        },
    ],
    component: ({providedInputs, configName, debugMode}) => {
        return (
            <CoeditingDocumentTool
                configName={configName}
                providedInputs={providedInputs}
                debugMode={debugMode}
            />
        );
    },
};
